export const STICKY_HEADER_HEIGHT = 98;
export const HEADER_OFFSET_SCROLL = 70; // отступ сверху при скролле до якоря
export const SECTION_PADDING_TOP = 40; // внутренний отступ у блоков с якорем
